import Hero from "@/components/home/Hero";
import TrustedMarquee from "@/components/home/TrustedMarquee";
import ProductsGrid from "@/components/home/ProductsGrid";
import WhyColecle from "@/components/home/WhyColecle";
import IndustrySolutions from "@/components/home/IndustrySolutions";
import HowItWorks from "@/components/home/HowItWorks";
import Security from "@/components/home/Security";
import Deployment from "@/components/home/Deployment";
import Testimonials from "@/components/home/Testimonials";
import DemoCTA from "@/components/home/DemoCTA";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Hero />
            <TrustedMarquee />
            <ProductsGrid />
            <WhyColecle />
            <IndustrySolutions />
            <HowItWorks />
            <Security />
            <Deployment />
            <Testimonials />
            <DemoCTA />
        </main>
    );
}
